import { Dispatch } from '@reduxjs/toolkit'
import { TokenStorage } from 'api/tokenStorage'
import { identitySlice } from 'store/identity/identity.slice'
import { transactionSlice } from 'store/transactions/transaction.slice'
import { IdentityApiClient } from 'utils/api/identityApi'
import { WalletsApiClient } from 'utils/api/walletsApiClient'

export const fetchInitialState =
  (identityApiClient: IdentityApiClient, walletsApiClient: WalletsApiClient) =>
  async (dispatch: Dispatch): Promise<void> => {
    try {
      if (TokenStorage.isAuthenticated()) {
        const [
          regions,
          countries,
          tickmillCompanies,
          filters,
          filterTypes,
          dateFormat,
          permissions,
          transactionTypes,
        ] = await Promise.all([
          identityApiClient.fetchRegions(),
          identityApiClient.fetchCountries(),
          identityApiClient.getTickmillCompanies(),
          identityApiClient.fetchFilters(),
          identityApiClient.fetchFilterType(),
          identityApiClient.fetchDateFormat(),
          identityApiClient.fetchPermissions(),
          walletsApiClient.getTransactionTypes(),
        ])
        const departments = await identityApiClient.fetchDepartments()

        dispatch(identitySlice.actions.fetchRegions(regions))
        dispatch(identitySlice.actions.fetchCountries(countries))
        dispatch(identitySlice.actions.fetchTickmillCompanies(tickmillCompanies))
        dispatch(identitySlice.actions.fetchFilters(filters))
        dispatch(identitySlice.actions.fetchFilterTypes(filterTypes))
        dispatch(identitySlice.actions.fetchDateFormat(dateFormat))
        dispatch(identitySlice.actions.fetchPermissions(permissions))
        dispatch(identitySlice.actions.fetchDepartments(departments))
        dispatch(transactionSlice.actions.setTransactionTypeAction(transactionTypes))
      }
    } finally {
      /* empty */
    }
  }
